<template>
  <p :class="pclass">
    {{ $t(`operators.${permission}`) }}

    <span class="is-pulled-right">
      <b-switch
        size="is-small"
        class="switch switch-adjusted-top"
        type="is-primary"
        v-model="$parent.operator.permissions[permission]"
        passive-type="is-secondary"
      ></b-switch>

      {{
        $parent.operator.permissions[permission]
          ? $t("common.yes")
          : $t("common.no")
      }}
    </span>
  </p>
</template>

<script>
export default {
  props: ["pclass", "permission"]
};
</script>
